import { useEffect, useState } from 'react';
import ThemeToggle from './ThemeToggle';
import { useTheme } from 'next-themes';

export default function ThemeToggleContainer() {
  const { theme, setTheme } = useTheme();

  return <ThemeToggle theme={theme} onChange={setTheme} />;
}
